import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { exchangeCode } from "../services/auth.js";
import ErrorBubble from "../components/ErrorBubble.jsx";

export default function Callback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  // Derive initial error from query params synchronously during render
  const [error, setError] = useState(() => {
    const errParam = params.get("error_description") || params.get("error");
    if (errParam) return errParam;
    if (!params.get("code")) return "Missing authorization code";
    return null;
  });

  useEffect(() => {
    if (error) return;
    const code = params.get("code");
    if (!code) return;

    exchangeCode(code)
      .then(() => navigate("/", { replace: true }))
      .catch((err) => setError(err.message));
    // Only run the exchange once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="login-page">
      <div className="login-card">
        {error ? (
          <>
            <h1>Sign-in failed</h1>
            <ErrorBubble message={error} />
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate("/login", { replace: true })}
            >
              Try again
            </button>
          </>
        ) : (
          <>
            <h1>Signing you in…</h1>
            <p>One moment while we complete authentication.</p>
          </>
        )}
      </div>
    </main>
  );
}
